export enum ChartType {
  Bar = 'bar',
  Line = 'line',
  Doughnut = 'doughnut',
}
